import { createSlice } from "@reduxjs/toolkit";
const CartSlice = createSlice({
    name: 'products',
    initialState: {
        cart:[],
        address_details:{}
    },
    reducers: {
     
        addToCart: (state, action) => {
            const itemInCart = state.cart.find((item) => item._id === action.payload._id);
            if (itemInCart) {
              itemInCart.quantity++;
              
            } else {
              state.cart.push({ ...action.payload});
            }
          },
          setAddressDetails:(state, action) => {
          state.address_details=action.payload
          },
          incrementQuantity: (state, action) => {
            const item = state.cart.find((item) => item._id === action.payload);
            if(item.quantity<item.countInStock ){
              
              item.quantity++;
            }
          },
          decrementQuantity: (state, action) => {
            const item = state.cart.find((item) => item._id === action.payload);
            if (item.quantity === 1) {
              item.quantity = 1
            } else {
              item.quantity--;
            }
          },
          removeItem: (state, action) => {
            const removeItem = state.cart.filter((item) => item._id !== action.payload);
            state.cart = removeItem;
          },
          makecartempty: (state, action) => {
           
            state.cart =[];
          },
     
    },
  })
  export const cartReducer = CartSlice.reducer;
  export const {
    addToCart,
    incrementQuantity,
    decrementQuantity,
    removeItem,
    makecartempty,
    setAddressDetails
  } = CartSlice.actions;
  